import React, { useMemo, useState } from 'react';
import '../../styles/AreaAccessSelector.css';

const AREA_CARDS = [
  {
    id: 'operacional',
    title: 'Operacional',
    description: 'Multi atendimento, gestao de chamados e satisfacao.',
  },
  {
    id: 'gestao',
    title: 'Gestao',
    description: 'Visao executiva de chamados, SLA, ITIL e controles.',
  },
  {
    id: 'tecnico',
    title: 'Tecnico',
    description: 'Projetos SW, knowledge base e relatorios tecnicos.',
  },
  {
    id: 'ti',
    title: 'TI',
    description: 'Fluxos de infraestrutura e projetos de suporte interno.',
  },
  {
    id: 'comercial',
    title: 'Comercial',
    description: 'CRM comercial (em construcao) e visao de pipeline.',
  },
];

const readJsonArray = (value, fallback = []) => {
  try {
    const parsed = JSON.parse(value || '[]');
    if (Array.isArray(parsed)) return parsed;
  } catch (error) {}
  return fallback;
};

const AreaAccessSelector = ({ onConfirm, onLogout }) => {
  const role = String(localStorage.getItem('role') || '').toLowerCase();
  const department = String(localStorage.getItem('department') || 'operacional').toLowerCase();
  const suggestedActiveArea = String(localStorage.getItem('activeArea') || '').toLowerCase();
  const availableAreas = readJsonArray(localStorage.getItem('availableAreas'), [department]).map((item) => String(item || '').toLowerCase());

  const cards = useMemo(() => {
    const isAdmin = role === 'admin' || role === 'master';
    const isSupervisor = role === 'supervisor';
    const areaSet = new Set(availableAreas);
    const computed = AREA_CARDS.map((card) => {
      const enabledByPlan = areaSet.has(card.id);
      const allowedForRole = isAdmin || isSupervisor ? true : card.id === department;
      const enabled = enabledByPlan && allowedForRole;
      return {
        ...card,
        enabled,
        reason: enabledByPlan ? (allowedForRole ? '' : 'Nao liberado para seu perfil') : 'Area indisponivel para sua empresa',
      };
    });
    if (isAdmin) {
      computed.unshift({
        id: 'full',
        title: 'Painel Completo',
        description: 'Acesso total aos modulos para administracao da operacao.',
        enabled: true,
        reason: '',
      });
    }
    if (!computed.some((card) => card.enabled)) {
      return computed.map((card) => (
        card.id === department
          ? { ...card, enabled: true, reason: 'Acesso restrito: somente dashboard disponivel.' }
          : card
      ));
    }
    return computed;
  }, [role, department, availableAreas]);

  const defaultSelected = useMemo(() => {
    const preferred = cards.find((card) => card.id === suggestedActiveArea && card.enabled);
    if (preferred) return preferred.id;
    return cards.find((card) => card.enabled)?.id || '';
  }, [cards, suggestedActiveArea]);

  const [selected, setSelected] = useState(defaultSelected);

  const handleEnter = () => {
    if (!selected) return;
    localStorage.setItem('activeArea', selected);
    localStorage.removeItem('pendingAreaSelection');
    onConfirm();
  };

  return (
    <div className="area-selector">
      <div className="area-selector__panel">
        <div className="area-selector__header">
          <h2>Escolha sua area de trabalho</h2>
          <p>Selecione o painel que deseja acessar nesta sessao.</p>
        </div>

        <div className="area-selector__grid">
          {cards.map((card) => (
            <button
              key={card.id}
              className={`area-selector__card ${selected === card.id ? 'is-selected' : ''} ${card.enabled ? '' : 'is-disabled'}`}
              onClick={() => card.enabled && setSelected(card.id)}
              disabled={!card.enabled}
            >
              <div className="area-selector__card-head">
                <strong>{card.title}</strong>
                <span className={`area-selector__badge ${card.enabled ? 'ok' : 'off'}`}>
                  {card.enabled ? 'Disponivel' : 'Indisponivel'}
                </span>
              </div>
              <p>{card.description}</p>
              {!card.enabled && <small>{card.reason}</small>}
            </button>
          ))}
        </div>

        <div className="area-selector__actions">
          <button className="ghost" onClick={onLogout}>Trocar conta</button>
          <button onClick={handleEnter} disabled={!selected}>Entrar na area</button>
        </div>
      </div>
    </div>
  );
};

export default AreaAccessSelector;
